import { useEffect, useState } from 'react';

/**
 * @param {string} url
 * @returns {string | null}
 */
const extractFilename = (url) => {
	try {
		const urlObj = new URL(url, window.location.origin);
		const pathname = urlObj.pathname;
		return pathname.substring(pathname.lastIndexOf('/') + 1);
	} catch (error) {
		console.error('Invalid URL:', error);
		return null;
	}
};

/**
 * @param {string | undefined} url
 */
const useBlobUrl = (url) => {
	const [blobUrl, setBlobUrl] = useState(/** @type {string | null} */ (null));
	const [error, setError] = useState(/** @type {Error | null} */ (null));

	useEffect(() => {
		if (!url) {
			setBlobUrl(null);
			setError(null);
			return;
		}
		let cancelled = false;
		let createdUrl = '';
		setError(null);
		fetch(url, { mode: 'cors', credentials: 'omit' })
			.then((res) => {
				if (!res.ok) throw new Error(`HTTP ${res.status}`);
				return res.blob();
			})
			.then((blob) => {
				if (cancelled) return;
				const pdfBlob = blob.type === 'application/pdf' ? blob : new Blob([blob], { type: 'application/pdf' });
				createdUrl = URL.createObjectURL(pdfBlob);
				setBlobUrl(createdUrl);
			})
			.catch((err) => {
				if (!cancelled) setError(err);
			});
		return () => {
			cancelled = true;
			if (createdUrl) URL.revokeObjectURL(createdUrl);
		};
	}, [url]);

	return { blobUrl, error };
};

/**
 * @param {{ selectedPdf: string | undefined }} props
 */
function PdfPreviewFrame({ selectedPdf }) {
	const { blobUrl, error } = useBlobUrl(selectedPdf);

	if (!selectedPdf) return null;

	const pdfName = decodeURIComponent(extractFilename(selectedPdf) || '');

	return (
		<div
			style={{
				position: 'absolute',
				left: '1070px',
				width: 720,
				border: '1px solid lightgray',
				backgroundColor: 'white',
				padding: 15,
				borderRadius: 6,
			}}
		>
			<div
				style={{
					fontSize: 12,
					fontWeight: 600,
					paddingBottom: 10,
					whiteSpace: 'nowrap',
					overflow: 'hidden',
					textOverflow: 'ellipsis',
				}}
				title={pdfName}
			>
				{pdfName}
			</div>
			{error && (
				<div style={{ padding: 16, textAlign: 'center', color: '#6b7280', fontSize: 13 }}>
					Unable to load PDF.{' '}
					<a href={selectedPdf} target='_blank' rel='noopener noreferrer'>
						Open in new tab
					</a>
				</div>
			)}
			{!error && !blobUrl && (
				<div style={{ padding: 16, textAlign: 'center', color: '#6b7280', fontSize: 13 }}>Loading preview…</div>
			)}
			{blobUrl && (
				<iframe
					src={blobUrl}
					title={pdfName}
					style={{
						width: '100%',
						height: '80vh',
						border: '1px solid #e5e7eb',
						borderRadius: 4,
						background: '#fff',
					}}
				/>
			)}
		</div>
	);
}

export default PdfPreviewFrame;
